// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Filters__fieldsContainer___t0YUZ {
    display: flex;
    flex-direction: row;
    padding: 0.8rem 1.2rem;
}

.Filters__fieldsContainer___t0YUZ .Filters__selectField___eDFr2 {
    width: 11.7rem;
}

.Filters__fieldsContainer___t0YUZ .Filters__findText___OaT9d {
    flex-grow: 1;
    width: 34.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/SpeedLawsModal/components/Filters/Filters.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB","sourcesContent":[".fieldsContainer {\n    display: flex;\n    flex-direction: row;\n    padding: 0.8rem 1.2rem;\n}\n\n.fieldsContainer .selectField {\n    width: 11.7rem;\n}\n\n.fieldsContainer .findText {\n    flex-grow: 1;\n    width: 34.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldsContainer": `Filters__fieldsContainer___t0YUZ`,
	"selectField": `Filters__selectField___eDFr2`,
	"findText": `Filters__findText___OaT9d`
};
export default ___CSS_LOADER_EXPORT___;
